"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessToErrorMapping = exports.ActionTypes = void 0;
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["GET_CART"] = "GET_CART";
    ActionTypes["GET_CART_FAILED"] = "GET_CART_FAILED";
    ActionTypes["ADD_ITEM_CART"] = "ADD_ITEM_CART";
    ActionTypes["ADD_ITEM_CART_FAILED"] = "ADD_ITEM_CART_FAILED";
    ActionTypes["REOPEN_CART"] = "REOPEN_CART";
    ActionTypes["REOPEN_CART_FAILED"] = "REOPEN_CART_FAILED";
    ActionTypes["REMOVE_ITEM_CART"] = "REMOVE_ITEM_CART";
    ActionTypes["REMOVE_ITEM_CART_FAILED"] = "REMOVE_ITEM_CART_FAILED";
    ActionTypes["RECOVER_EXPIRED_CART"] = "RECOVER_EXPIRED_CART";
    ActionTypes["RECOVER_EXPIRED_CART_FAILED"] = "RECOVER_EXPIRED_CART_FAILED";
    ActionTypes["FREEZE_CART"] = "FREEZE_CART";
    ActionTypes["FREEZE_CART_FAILED"] = "FREEZE_CART_FAILED";
    ActionTypes["GET_DETAILED_CART"] = "GET_DETAILED_CART";
    ActionTypes["GET_DETAILED_CART_FAILED"] = "GET_DETAILED_CART_FAILED";
    ActionTypes["DEFROST_CART"] = "DEFROST_CART";
    ActionTypes["DEFROST_CART_FAILED"] = "DEFROST_CART_FAILED";
    ActionTypes["CANCEL_RECOVER_CART"] = "CANCEL_RECOVER_CART";
    ActionTypes["CANCEL_RECOVER_CART_FAILED"] = "CANCEL_RECOVER_CART_FAILED";
    ActionTypes["REQUEST"] = "REQUEST";
    ActionTypes["DELETE_CART"] = "DELETE_CART";
    ActionTypes["DELETE_CART_FAILED"] = "DELETE_CART_FAILED";
    ActionTypes["ADD_LOYALTY"] = "ADD_LOYALTY";
    ActionTypes["ADD_LOYALTY_FAILED"] = "ADD_LOYALTY_FAILED";
    ActionTypes["REMOVE_LOYALTY"] = "REMOVE_LOYALTY";
    ActionTypes["REMOVE_LOYALTY_FAILED"] = "REMOVE_LOYALTY_FAILED";
})(ActionTypes || (exports.ActionTypes = ActionTypes = {}));
exports.SuccessToErrorMapping = {
    [ActionTypes.GET_CART]: ActionTypes.GET_CART_FAILED,
    [ActionTypes.ADD_ITEM_CART]: ActionTypes.ADD_ITEM_CART_FAILED,
    [ActionTypes.REMOVE_ITEM_CART]: ActionTypes.REMOVE_ITEM_CART_FAILED,
    [ActionTypes.FREEZE_CART]: ActionTypes.FREEZE_CART_FAILED,
    [ActionTypes.RECOVER_EXPIRED_CART]: ActionTypes.RECOVER_EXPIRED_CART_FAILED,
    [ActionTypes.GET_DETAILED_CART]: ActionTypes.GET_DETAILED_CART_FAILED,
    [ActionTypes.DEFROST_CART]: ActionTypes.DEFROST_CART_FAILED,
    [ActionTypes.CANCEL_RECOVER_CART]: ActionTypes.CANCEL_RECOVER_CART_FAILED,
    [ActionTypes.DELETE_CART]: ActionTypes.DELETE_CART_FAILED,
    [ActionTypes.REMOVE_LOYALTY]: ActionTypes.REMOVE_LOYALTY_FAILED,
    [ActionTypes.ADD_LOYALTY]: ActionTypes.ADD_LOYALTY_FAILED,
    [ActionTypes.REOPEN_CART]: ActionTypes.REOPEN_CART_FAILED,
};
